import AirSlider from "./AirSlider"

export default  AirSlider;



// WEBPACK FOOTER //
// ./src/common/components/AirSlider/index.js